import React from 'react';
import builderPathInit from '../../util/builder-path-init';

// set up builder and register custom components
builderPathInit({
  model: 'navbar',
  pathPrefix: 'b/navbar-preview',
  noIndex: true,
});

/**
 * When rendered inside the builder preview, it will override the default nav.
 */
function NavbarPreview() {
  return (
    <p>
      <b>This is a preview of the navbar. 
        Due to the implementation, click the page below, or refresh the iframe to see updates.</b>
    </p>
  );
}

export default NavbarPreview;
